// export const testSite = 'gamification test site'
export const NewPlayerMaxLevel: number = 1
export const NewPlayerMaxSublevel: number = 3
// export const firstYearOfDevelopment: number = 2017
export const validImageFileLength: number = 20000
export const ComingSoon: number = 2
export const ImageLeft: number = 0
export const ImageRight: number = 1
export const CategoriesStart: number = 3
export const CategoriesAll: number = 9
export const Items: number = 12

// export const OK: string = 'OK'
// export const CurrencyEUR: string = 'EUR'

export const reactDatesGreyColor:string = 'reactDatesGrey'

export const dateFormatDB:string = 'YYYY-MM-DD'
export const dateFormatDisplay:string = 'DD-MM-YYYY'
export const none: string = 'none'
export const enum T {
    YourRewardPointsBalance = 0,
    Balance,
    MyTransactionsHistory,
    MaxNumberOfRecordsSinglePage,
    ListMoveTop,
    ListMovePrevious,
    ListMoveNext,
    ListMoveBottom,
    page,
    showing,
    showingRecords,
    records,
    recordsShort,
    PurchaseIDShort,
    PurchaseID,
    ItemName,
    Item,
    Date,
    Time,
    Quantity,
    Price,
    Value,
    Before,
    BalanceBeforePurchase,
    After,
    BalanceAfterPurchase,
    ConfirmPurchase,
    Info,
    Cancel,
    Buy,
    NotificationOutOfPoints,
    LoadingCargo,
    ScandibetRewardShop,
    WhatYouCanBuy,
    WelcomeToTheShop,
    BuyRewardShopItem,
    ChooseCategory,
    ChooseCategoryToEnter,
    ThereAreNoTransactions,
    Category,
    Level,
    ShowItemsInCategory,
    isSelected,
    AnyCategory,
    AnyItem,
    StartDate,
    EndDate,
    FilterByDate,
    FilterByCategory,
    FilterByItem,
    Coins,
    VikingCoinBalance,
    LinkText,
    Link,
    UnlocksAt,
    Ok
}
/*
export const LANGUAGE_SCANDIBET_GREAT_BRITAIN = 7
export const LANGUAGE_SCANDIBET_DENMARK = 6
export const LANGUAGE_SCANDIBET_NEW_ZEALAND = 5
export const LANGUAGE_SCANDIBET_CANADA = 4
export const LANGUAGE_SCANDIBET_SWEDEN = 3
export const LANGUAGE_SCANDIBET_NORWAY = 2
export const LANGUAGE_SCANDIBET_FINLAND = 1
export const LANGUAGE_SCANDIBET_EUROPE = 0
*/
export const enum LANGUAGE_SCANDIBET {EUROPE, FINLAND, NORWAY, SWEDEN, CANADA, NEW_ZEALAND, DENMARK, GREAT_BRITAIN}

export const COLOR_WOOD:string = '#966f33'
export const COLOR_AMBER:string = '#ffc200'
export const COLOR_BRONZE:string = '#cd7f32'
export const COLOR_SILVER:string = '#c0c0c0'
export const COLOR_GOLD:string = '#ffd700'
export const COLOR_DIAMOND: string = '#b9f2ff'
export const COLOR_PLATINUM:string = '#e5e4e2'
export const COLOR_VALHALLA:string = '#337ab7'
export const COLOR_STONE: string = '#727b84'
export const COLOR_IRON: string = '#CBCDCD'

export const COLORS_5: string[] = [COLOR_WOOD, COLOR_STONE, COLOR_AMBER, COLOR_IRON, COLOR_BRONZE, COLOR_SILVER, COLOR_GOLD, COLOR_PLATINUM, COLOR_DIAMOND, COLOR_VALHALLA]

export const UTC: string = 'UTC'
/*
export const zeroPng: string =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII='

export const PointsInitValue: number = 500
export const _: string = '–||–'

export const rewards: number[] = [500, 300, 200]
export const W: number = 1330
export const innerWidthF = 1200
export const innerWidthN = 1000
export const L: number = 350
export const mF: number = 10
export const mN: number = 20

export const DefaultCurrencyShort: string = '€'
export const DefaultCurrency: string = 'EUR'
export const Login: string = 'Log in'
export const LogIn: string = 'Login'
export const Logout: string = 'Logout'
export const LoggedIn: string = 'Logged in:'
export const Username: string = 'Username'
export const Password: string = 'Password'

export const Name: string = 'Name'
export const Email: string = 'Email'
export const Search: string = 'Search'
export const SearchGames: string = Search + ' games'
export const SearchRewardShopItems: string = 'Search through the Reward Shop Items'

export const XPPoints: string = 'Available Points'
export const XPLPoints: string = 'Total Points'
export const Id: string = 'Id'
export const Points: string = 'Points'
export const _Points: string = ' ' + Points
export const NextLevel: string = 'Next Level: '
export const NextSublevel: string = 'Next Sublevel: '
export const _Collected: string = '#Collected: '
export const _Required: string = '#Required: '
export const _Progress: string = 'Progress: '
export const Collected: string = 'Collected: '
export const BonusByGame: string = 'Bonus By Game'

export const CreateAnAccount: string = 'CREATE AN ACCOUNT'
export const Register: string = 'Register'
export const Deposit: string = 'DEPOSIT'


export const EditAnAccount: string = 'UPDATE THE ACCOUNT'
export const playerAlreadyExists: string = 'Player with this username already exists, please choose another.'

export const Level: string = 'Level'
export const Sublevel: string = 'Sub-Level'

export const warning: string = 'fa fa-exclamation-triangle'
export const caretDown: string = 'fa fa-caret-down'
export const caretUp: string = 'fa fa-caret-up'
export const history: string = 'fa fa-history'
export const expand: string = 'fa fa-expand'
export const compress: string = 'fa fa-compress'

export const numericDesc: string = 'fa fa-sort-numeric-desc'
export const numericAsc: string = 'fa fa-sort-numeric-asc'

export const alphaDesc: string = 'fa fa-sort-alpha-desc'
export const alphaAsc: string = 'fa fa-sort-alpha-asc'

export const amountDesc: string = 'fa fa-sort-amount-desc'
export const amountAsc: string = 'fa fa-sort-amount-asc'

export const longArrowUp: string = 'fa fa-long-arrow-up'
export const longArrowDown: string = 'fa fa-long-arrow-down'
export const percent: string = 'fa fa-percent'
export const calendar: string = 'fa fa-calendar'
export const circle: string = 'fa fa-circle'
export const cancel: string = 'fa fa-times'
export const cancelCircle: string = 'fa fa-times-circle-o'
export const arrowUp: string = 'fa fa-arrow-up'
export const arrowDown: string = 'fa fa-arrow-down'
export const faPrevButtonClass: string = 'fa fa-arrow-left'
export const faNextButtonClass: string = 'fa fa-arrow-right'
export const faFirstButtonClass: string = 'fa fa-arrow-up'
export const faLastButtonClass: string = 'fa fa-arrow-down'

export const faPrevClass: string = 'fa fa-angle-left'
export const faNextClass: string = 'fa fa-angle-right'

export const informationCircle: string = 'fa fa-info-circle'
export const information: string = 'fa fa-info'
export const leaderboard: string = 'fa fa-list-ol'

export const question: string = 'fa fa-question'
export const hamburger: string = 'fa fa-bars'
export const shoppingCart: string = 'fa fa-shopping-cart'
export const shoppingBasket: string = 'fa fa-shopping-basket'
export const plusCircle: string = 'fa fa-plus-circle'
export const plus: string = 'fa fa-plus'
export const minus: string = 'fa fa-minus'
export const barChart: string = 'fa fa-bar-chart'
export const bars: string = 'fa fa-bars'
export const star: string = 'fa fa-star'
export const stars: string = 'fa fa-star-o'
export const point: string = 'fa fa-trophy'
export const filter: string = 'fa fa-filter'
export const filterLg: string = 'fa fa-filter fa-lg'
*/


// WEBPACK FOOTER //
// ./src/Assets/Assets.ts